import React from "react";
import { Link } from "react-router-dom";

// project-imports
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";

const OrderDetailHeader = ({ title, rootUrl, parentUrl, currentUrl, googleEnum }) => {

    return (
        <div className="edu-breadcrumb-area-order breadcrumb-style-1 ptb--30 ptb_md--20 ptb_sm--20 bg-image rounded-4 mb-3">
            <div className="container eduvibe-animated-shape px-4">
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-3 col-lg-6">
                        <div className="breadcrumb-inner text-start">
                            <div >
                                <Link to={process.env.PUBLIC_URL + "/"}>
                                    <img className="logo-light" src="/images/logo/lsa-long-logo-white.png" alt="Main Logo" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-9 col-lg-6 text-sm-end align-content-center">
                        <ul className="list-unstyled mb-2">
                            <li className="text-light text-break m-0 text-uppercase d-flex justify-content-sm-end">{process.env.REACT_APP_OFFICIAL_ADDRESS_1}</li>
                            <li className="text-light text-break m-0 text-uppercase d-flex justify-content-sm-end">{process.env.REACT_APP_OFFICIAL_ADDRESS_2}</li>
                            <li className="text-light text-break m-0 d-flex justify-content-sm-end"><i class="ri-mail-line px-1"></i>{process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS}</li>
                            <li className="text-light text-break m-0 d-flex justify-content-sm-end"><i class="ri-phone-line px-1"></i>{process.env.REACT_APP_OFFICIAL_PHONE_NUMBER}</li>
                        </ul>
                    </div>
                </div>
                {/* Modified by Longswitch Team added xxl for that nest hub max scroll issue  */}
                <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-01-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-5">
                        <img src="/images/shapes/shape-03.png" alt="Shape Thumb" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderDetailHeader;